export const planIsAtLeast = (userPlan, atLeastPlan) => {
  if (userPlan === 'premium_plus') {
    return true
  }

  if (userPlan === 'premium') {
    return ['premium', 'basic', 'free'].includes(atLeastPlan)
  }

  if (userPlan === 'basic') {
    return ['basic', 'free'].includes(atLeastPlan)
  }

  if (userPlan === 'free') {
    return ['free'].includes(atLeastPlan)
  }

  return false
}

export const userIsAtLeast = (user, atLeastPlan) => {
  if (!user) {
    return false
  }

  if (user.admin) {
    return true
  }

  return planIsAtLeast(user.subscription?.plan, atLeastPlan)
}
